import React from 'react';
import '../home-style/home-style.css';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <p>&copy; 2019 Asados al Barril.</p>
        </footer>
    );
};

export default Footer;